/* eslint-disable @typescript-eslint/naming-convention */
import { getLocationTypeList, getLocationListByType } from 'features/Location/services/location'
import {
  getReplenishmentConfig,
  GetReplenishmentConfigParameterType,
  ReplenishmentConfigParamsType,
  updateReplenishmentConfig,
  UpdateReplenishmentConfigRequestType,
} from 'features/SupplyOrder/services/replenishment'
import { getWimsConstants, getWimsStorageHandlings } from 'features/Product/services/productAdd'
import { callErrorMsg } from 'helpers/errorMsg'
import { AppDispatchType, RootStateType } from 'store'
import { toastSuccess } from 'utils/toast'
import {
  setModalUpdate,
  setIsLoading,
  setLocationTypeList,
  setLocationDataList,
  setReplenishmentConfigListData,
  setMapStorageIdToName,
  resetModalUpdate,
} from './slice'

export const actFetchLocationTypeList = () => async (dispatch: AppDispatchType) => {
  try {
    const { data } = await getLocationTypeList()
    dispatch(setLocationTypeList(data.data))
  } catch (err) {
    callErrorMsg(err)
  }
}

export const actFetchLocationByType =
  (locationType: string) => async (dispatch: AppDispatchType) => {
    try {
      const { data } = await getLocationListByType(locationType)
      dispatch(setLocationDataList(data))
    } catch (err) {
      callErrorMsg(err)
    }
  }

const getQueryParamsReplenishConfig = (params: GetReplenishmentConfigParameterType) => {
  const paramToSubmit: ReplenishmentConfigParamsType = {
    'pagination.page_size': params.page_size,
    'pagination.page_index': params.page_index,
  }
  if (params?.location_ids && params?.location_ids.length > 0) {
    paramToSubmit.location_ids = params?.location_ids[0].toString()
  }
  if (params?.product_name_or_sku) {
    paramToSubmit.product_name_or_sku = params.product_name_or_sku
  }
  return paramToSubmit
}

export const actFetchReplenishmentConfigList =
  () => async (dispatch: AppDispatchType, getState: () => RootStateType) => {
    const { params } = getState().replenishmentConfig
    try {
      const paramsToSubmit = getQueryParamsReplenishConfig(params)
      const { data } = await getReplenishmentConfig(paramsToSubmit)
      dispatch(setReplenishmentConfigListData(data.data))
    } catch (err) {
      callErrorMsg(err)
    }
  }

export const actFetchStorageHandlings = () => async (dispatch: AppDispatchType) => {
  try {
    const { data } = await getWimsConstants()
    const storageTypeIds = data.data?.replenishment_config_storage_type_ids
    const storageHandlingResponse = await getWimsStorageHandlings({ ids: storageTypeIds })

    const newData = Object.fromEntries(
      storageHandlingResponse.data.data.map((item) => [item.id, item.name]),
    ) as Record<number, string>

    dispatch(setMapStorageIdToName(newData))
  } catch (err) {
    callErrorMsg(err)
  }
}

export const actInitializeData = () => async (dispatch: AppDispatchType) => {
  dispatch(setIsLoading(true))
  try {
    await dispatch(actFetchReplenishmentConfigList())
    await dispatch(actFetchStorageHandlings())
  } finally {
    dispatch(setIsLoading(false))
  }
}

export const actUpdateReplenishmentConfig =
  (formData: UpdateReplenishmentConfigRequestType) => async (dispatch: AppDispatchType) => {
    try {
      dispatch(
        setModalUpdate({
          isSubmittingData: true,
        }),
      )
      const { data } = await updateReplenishmentConfig(formData)
      toastSuccess(data.message)
      dispatch(resetModalUpdate())
      dispatch(actFetchReplenishmentConfigList())
    } catch (err) {
      callErrorMsg(err)
    } finally {
      dispatch(
        setModalUpdate({
          isSubmittingData: false,
        }),
      )
    }
  }
